import { Component } from 'san';
import * as _ from 'lodash';

import {
    IShowCheckProjectsParams,
    ICheckProjectsCallback,
    IProject,
    IProjectsParams
} from 'src/models';

import ProjectFilters from '../ProjectFilters/ProjectFilters';
import ProjectsList from '../ProjectsList/ProjectsList';
import Pagination from '../Pagination/Pagination';

import projectService from 'src/services/project.service';
import { PAGE_SIZE } from 'src/consts';
import { IShowingCheckProjectsCallback } from 'src/models/checkProjects';
import { ESearchMode } from 'src/enums';

export default class CheckChangeProjects extends Component {
    static components = {
        'ui-project-filters': ProjectFilters,
        'ui-projects-list': ProjectsList,
        'ui-pagination': Pagination
    }

    static computed = {
        checkedProjects() {
            const projects = this.data.get('projects');
            return _.filter(projects, { _is_checked: true });
        }
    }

    messages = {
        'UI:project-filters-changed': (arg) => {
            console.log('message filters:', arg);
            const params = arg.value.params;
            params.page = 1;
            this.data.set('params', params);
            this.getProjects(params);
        }
    }

    constructor(options: any) {
        super(options);
    }

    initData(): {
        isShow: boolean;
        callback: ICheckProjectsCallback;  // 点击提交的回调方法
        showCallback: IShowingCheckProjectsCallback; // 显示|隐藏 的回调方法
        projects: IProject[];   // {==}
        params: IProjectsParams;
        page: number;
        total: number;
        searchMode: ESearchMode; // 搜索模式：默认/精准模式
        searchModeEnum: any;
    } {
        return {
            isShow: false,
            callback: undefined,
            showCallback: undefined,
            projects: [],
            params: {
                status: ['un-received', 'un-submitted'] // 流程状态：[未接收、未提交]
            },
            page: 1,
            total: 0,
            searchMode: ESearchMode.Default,
            searchModeEnum: ESearchMode,
        };
    }

    //#region owner调用
    show(params: IShowCheckProjectsParams) {
        this.data.set('callback', params.callback);
        this.data.set('showCallback', params.showCallback);
        this.changeShow(true);
        this.goToPage({ page: 1, limit: PAGE_SIZE })
    }
    //#endregion

    getProjects(params: IProjectsParams) {
        projectService.getProjects(params).then((projects) => {
            const oldProjects = this.data.get('projects');
            this.data.splice('projects', [0, oldProjects.length].concat(projects));
        });
        projectService.getProjectsCount(params).then((count) => {
            this.data.set('page', params.page || 1);
            this.data.set('total', count);
        });
    }

    toggleSearchMode(searchMode: ESearchMode) {
        this.data.set('searchMode', searchMode);
    }

    goToPage(pageParams: {
        page: number;
        limit: number;
    }) {
        const params = this.data.get('params');
        params.page = pageParams.page;
        params.limit = pageParams.limit;
        this.getProjects(params);
    }

    submit() {
        const checkedProjects = this.data.get('checkedProjects');
        const callback = this.data.get('callback');
        if (callback) {
            callback(checkedProjects);
        }
        this.cancel();
    }

    cancel() {
        const dataKey = 'projects';
        const projects = this.data.get(dataKey);
        this.data.splice(dataKey, [0, projects.length]);
        this.changeShow(false);
    }

    // 显示|隐藏
    changeShow(isShow: boolean) {
        this.data.set('isShow', isShow);
        const showCallback = this.data.get('showCallback');
        if (showCallback) {
            showCallback(isShow);
        }
    }
}